export const getPreviewMode = (url) => {
    const segments = typeof url === "string" ? url.split("/") : [];
    return ((segments === null || segments === void 0 ? void 0 : segments[1]) === "cdp-preview" ||
        ((segments === null || segments === void 0 ? void 0 : segments[1]) === "projekte" && (segments === null || segments === void 0 ? void 0 : segments[2]) === "expose-preview"));
};
